import React, { useEffect, useState } from 'react';
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography,
    List,
    ListItem,
    ListItemText,
    Badge,
    makeStyles,
    TextField,
    FormControlLabel,
    Tooltip,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import InfoIcon from '../../../../../../src/assets/icons/info-icon.svg';
import PassiveRadioIcon from '../../../../../assets/icons/passive-radio-icon.svg';
import ActiveRadioIcon from '../../../../../assets/icons/active-radio-icon.svg';
import VerticalChartIcon from '../../../../../assets/icons/dasboardIcons/vertical-chart-icon.svg';
import HorizontalChartIcon from '../../../../../assets/icons/dasboardIcons/horizontal-chart-icon.svg';
import GroupableVerticalChartIcon from '../../../../../assets/icons/dasboardIcons/vertical-groupable-chart-icon.svg';
import GroupableHorizontalChartIcon from '../../../../../assets/icons/dasboardIcons/horizontal-groupable-chart-icon.svg';
import PieChartIcon from '../../../../../assets/icons/dasboardIcons/pie-chart-icon.svg';
import StringIcon from '../../../../../assets/icons/dasboardIcons/string-icon.svg';
import { useTranslation } from 'react-i18next';
import { Autocomplete } from '@material-ui/lab';
import WidgetCondition from './WidgetConditions/WidgetCondition';
import { GreenSwitch } from '../../../../../components/FlowConfigurationInputs';
import { alertState } from '../../../../../recoil-store/recoil-state';
import { useSetRecoilState } from 'recoil';

const useStyles = makeStyles((theme) => ({
    accordionRoot: {
        marginBottom: theme.spacing(2),
        border: "0.5px solid #CFCFCF",
        borderRadius: "5px",
        boxShadow: "none"
    },
    summaryContent: {
        display: 'flex',
        alignItems: "center",
        gap: "10px",
        width: '100%',
    },
    listItem: {
        display: 'flex',
        gap: "10px",
        paddingTop: "0",
        paddingBottom: "8px",
        alignItems: "center"
    },
    badge: {
        marginLeft: "10px",
        backgroundColor: "#4F6E90",
        color: "#FFFFFF"
    },
}));

const ReportsAccordion = ({ data, selectedData, setSelectedData, label, step, selectedReport, columns, completeData, setCompleteData, returnToDefault, widgets }) => {
    const classes = useStyles();
    const [expanded, setExpanded] = useState({ "COLUMNS": true, "GROUP-BY": false, "CUSTOM-FILTERS": false, "SORTING": false, "WIDGET-VISUALIZATION": false })
    const { t } = useTranslation();
    const setAlert = useSetRecoilState(alertState);


    useEffect(() => {
        setExpanded({ "COLUMNS": true, "GROUP-BY": false, "CUSTOM-FILTERS": false, "SORTING": false, "WIDGET-VISUALIZATION": false })
    }, [selectedData])

    const handleSelectData = (item) => {
        setSelectedData(item)
        returnToDefault();
    }

    const handleShowColumnActions = (columnName) => {
        let finalHtml = ""
        switch (columnName) {
            case "GROUP-BY":
                if (selectedReport.group_by_columns?.length) {

                    finalHtml = <Autocomplete
                        className='db-filter-autocomplete'
                        value={completeData.groupBy}
                        onChange={(event, newValue) => {
                            const nonRemovable = selectedReport.group_by_columns.find((option) => option.disabled)
                            let finalValue = newValue
                            if (nonRemovable?.label) {
                                finalValue = nonRemovable
                            }
                            if (!finalValue && !completeData.columns?.length) {
                                handleChange(undefined, false, "SORTING")
                                setCompleteData(pre => {
                                    return { ...pre, groupBy: finalValue, sorting: null }
                                });
                            }
                            else {
                                setCompleteData(pre => {
                                    return { ...pre, groupBy: finalValue }
                                });
                            }
                        }}
                        options={selectedReport.group_by_columns}
                        getOptionLabel={(option) => {
                            return t(label + option.label)
                        }}
                        isOptionEqualToValue={(option, value) => option.id === value?.id}
                        size="small"
                        renderInput={(params) => (

                            <TextField
                                {...params}
                                id='operator-list-text'
                                className="select-action-input"
                                placeholder="Select a group"
                                variant="outlined"
                                classes={{
                                    root: classes.inputRoot
                                }}
                                inputProps={{
                                    ...params.inputProps,
                                    "aria-autocomplete": 'new-password',
                                    autoComplete: 'new-password', // disable autocomplete and autofill
                                    style: {
                                        fontSize: 12,
                                        fontWeight: 600,
                                        color: '#46474E'
                                    }
                                }}
                            />

                        )}
                    />
                }
                break;

            case "COLUMNS":
                if (selectedReport.columns?.length) {

                    finalHtml = <div className='db-required-container'>
                        <Autocomplete
                            className='db-filter-autocomplete'
                            multiple={true}
                            value={completeData.columns}
                            onChange={(event, newValue) => {
                                const nonRemovable = selectedReport.columns.filter((option) => option.disabled)
                                const finalValue = [...nonRemovable, ...newValue.filter(option => !option.disabled)];
                                // const isCannotRemove = nonRemovable.
                                // if (condition) {

                                // }
                                if (!finalValue.length && !completeData.groupBy) {
                                    handleChange(undefined, false, "SORTING")
                                    setCompleteData(pre => {
                                        return { ...pre, columns: finalValue, sorting: null }
                                    });
                                }
                                else {
                                    setCompleteData(pre => {
                                        return { ...pre, columns: finalValue }
                                    });
                                }
                            }}
                            options={selectedReport.columns}
                            getOptionLabel={(option) => {
                                return t(label + option.label)
                            }}
                            size="small"
                            // isOptionEqualToValue={(option, value) => option.id === value?.id}
                            renderInput={(params) => (

                                <TextField
                                    {...params}
                                    id='operator-list-text'
                                    className="select-action-input"
                                    label="Select a columns"
                                    InputLabelProps={{
                                        ...params.InputLabelProps,
                                        style: {
                                            fontSize: 13,
                                            fontWeight: 600
                                        }
                                    }}
                                    variant="outlined"
                                    classes={{
                                        root: classes.inputRoot
                                    }}
                                    inputProps={{
                                        ...params.inputProps,
                                        "aria-autocomplete": 'new-password',
                                        autoComplete: 'new-password', // disable autocomplete and autofill
                                        style: {
                                            fontSize: 12,
                                            fontWeight: 600,
                                            color: '#46474E'
                                        }
                                    }}
                                />

                            )}
                        />

                    </div>
                }
                break;
            case "SORTING":
                if (completeData.columns?.length || completeData.groupBy?.label) {
                    let sortingArray = []
                    if (completeData.columns?.length) {
                        sortingArray = JSON.parse(JSON.stringify(completeData.columns))
                    }
                    if (completeData.groupBy?.label) {
                        sortingArray.push(JSON.parse(JSON.stringify(completeData.groupBy)))
                    }
                    finalHtml = <div className='db-create-widget-sorting-container'>
                        <Autocomplete
                            className='db-filter-autocomplete'
                            value={completeData.sorting}
                            onChange={(event, newValue) => {
                                setCompleteData(pre => {
                                    const newSort = JSON.parse(JSON.stringify(pre))
                                    const value = newValue ? { ...newValue, type: newSort.sorting?.type ? newSort.sorting?.type : "asc" } : newValue
                                    return { ...pre, sorting: value }
                                });
                            }}
                            options={sortingArray}
                            getOptionLabel={(option) => {
                                return t(label + option.label)
                            }}
                            // isOptionEqualToValue={(option, value) => option.id === value?.id}
                            size="small"
                            renderInput={(params) => (

                                <TextField
                                    {...params}
                                    id='operator-list-text'
                                    className="select-action-input"
                                    label="Select an option"
                                    InputLabelProps={{
                                        ...params.InputLabelProps,
                                        style: {
                                            fontSize: 13,
                                            fontWeight: 600
                                        }
                                    }}
                                    variant="outlined"
                                    classes={{
                                        root: classes.inputRoot
                                    }}
                                    inputProps={{
                                        ...params.inputProps,
                                        "aria-autocomplete": 'new-password',
                                        autoComplete: 'new-password', // disable autocomplete and autofill
                                        style: {
                                            fontSize: 12,
                                            fontWeight: 600,
                                            color: '#46474E'
                                        }
                                    }}
                                />

                            )}
                        />
                        {completeData.sorting?.value ? <>
                            <div className='db-create-widget-asc-desc-container' onClick={() => {
                                setCompleteData(pre => {
                                    return { ...pre, sorting: { ...pre.sorting, type: "asc" } }
                                });
                            }}>
                                <img id='a' className='transform-radio-icon' src={completeData.sorting?.type === "asc" ? ActiveRadioIcon : PassiveRadioIcon} />
                                <span id='a' className='db-create-widget-asc-desc-text'>{t(label + "ASCENDING")}</span>
                            </div>
                            <div className='db-create-widget-asc-desc-container' onClick={() => {
                                setCompleteData(pre => {
                                    return { ...pre, sorting: { ...pre.sorting, type: "desc" } }
                                });
                            }} >
                                <img className='transform-radio-icon' src={completeData.sorting?.type === "desc" ? ActiveRadioIcon : PassiveRadioIcon} />
                                <span className='db-create-widget-asc-desc-text'>{t(label + "DESCENDING")}</span>
                            </div>
                        </> : ""
                        }
                    </div>
                }
                break;
            case "CUSTOM-FILTERS":
                finalHtml = completeData.customFilters.map((filter, index) => {
                    return <WidgetCondition filter={filter} columns={selectedReport.filter_columns} label={label} completeData={completeData}
                        setCompleteData={setCompleteData} selectedReport={selectedReport} index={index} />
                })
                break;
            case "WIDGET-VISUALIZATION":
                finalHtml = <div className='db-widget-select-container'>
                    {widgets.map((widget, index) => {
                        if (!checkCompatibleChart(widget)) {
                            if (completeData.widgetVisualization.id === widget.id && completeData.widgetVisualization.img) {
                                setCompleteData(pre => {
                                    return { ...pre, widgetVisualization: { ...pre.widgetVisualization.img } }
                                });
                            }
                            if (!completeData.columns?.length && completeData.widgetVisualization?.img) {
                                setCompleteData(pre => {
                                    return { ...pre, widgetVisualization: { ...pre.widgetVisualization.img } }
                                });
                            }
                            return ""
                        }
                        // return <div className='db-widget-select-item'><img src={handleFindImage(widget.name)} /></div>
                        return handleFindImage(widget)
                    })}
                </div>
                break;
            default:
                break;
        }
        return finalHtml
    }

    const checkCompatibleChart = (widget) => {
        if (completeData.groupBy?.value && ["vertical bar", "horizontal bar", "string chart", "pie chart"].includes(widget?.name)) {
            return ""
        }
        if (!completeData.groupBy?.value && ["groupable vertical bar", "groupable horizontal bar"].includes(widget?.name)) {
            return ""
        }
        if (completeData.columns?.length > 1 && ["string chart"].includes(widget?.name)) {
            return ""
        }
        if (completeData.columns?.length === 1 && ["pie chart", "vertical bar", "horizontal bar"].includes(widget?.name)) {
            return ""
        }
        return true
    }

    const handleCheckDisable = (columnName) => {
        let isDisabled = true
        switch (columnName) {
            // "GROUP-BY", "COLUMNS", "CUSTOM-FILTERS", "SORTING", "WIDGET-VISUALIZATION"
            case "GROUP-BY":
                if (selectedReport.group_by_columns?.length) {
                    isDisabled = false
                }
                break;
            case "COLUMNS":
                isDisabled = false
                break;
            case "SORTING":
                if (completeData.columns?.length || completeData.groupBy) {
                    isDisabled = false
                }
                break;
            case "CUSTOM-FILTERS":
                isDisabled = false
                break;

            case "WIDGET-VISUALIZATION":
                if (completeData.columns?.length) {
                    isDisabled = false
                }
                break;

            default:
                break;
        }
        const element = document.querySelector(`.db-accordion-${columnName}`)
        if (element) {
            element.style.opacity = isDisabled ? "0.5" : "1"
        }
        return isDisabled
    }
    // const handleCheckExpand = (name, isExpand) => {
    //     setExpanded((pre) => {
    //         const temp = JSON.parse(JSON.stringify(pre))
    //         temp[name] = isExpand
    //         return temp
    //     })
    // }

    const handleChange = (event, isExpanded, columnName) => {
        setExpanded((pre) => {
            const temp = JSON.parse(JSON.stringify(pre))
            temp[columnName] = isExpanded
            return temp
        });
    };

    const handleFindImage = (widget) => {
        const widgetName = widget.name
        switch (widgetName) {
            case "vertical bar":
                return <Tooltip title={t(label + "VERTICAL-CHART")} placement='top'>
                    <div className={`db-widget-select-item ${completeData.widgetVisualization?.id === widget.id ? "db-selected-widget" : ""}`} onClick={(e) => {
                        setCompleteData(pre => {
                            return { ...pre, widgetVisualization: { ...widget, img: VerticalChartIcon } }
                        });
                    }}>
                        <img src={VerticalChartIcon} />
                        <span className='db-widget-select-text'>{t(label + "X-AXIS")}</span>
                    </div></Tooltip>
                break;
            case "string chart":
                return <Tooltip title={t(label + "STRING")} placement='top'>
                    <div className={`db-widget-select-item ${completeData.widgetVisualization?.id === widget.id ? "db-selected-widget" : ""}`} onClick={(e) => {
                        setCompleteData(pre => {
                            return { ...pre, widgetVisualization: { ...widget, img: StringIcon } }
                        });
                    }}>
                        <img src={StringIcon} />
                        <span className='db-widget-select-text'>{t(label + "STRING")}</span>
                    </div></Tooltip>
                break;
            case "pie chart":
                return <Tooltip title={t(label + "PIE-CHART")} placement='top'>
                    <div className={`db-widget-select-item ${completeData.widgetVisualization?.id === widget.id ? "db-selected-widget" : ""}`} onClick={(e) => {
                        setCompleteData(pre => {
                            return { ...pre, widgetVisualization: { ...widget, img: PieChartIcon } }
                        });
                    }}>
                        <img src={PieChartIcon} />
                        <span className='db-widget-select-text'>{t(label + "PIE")}</span>
                    </div></Tooltip>
                break;
            case "groupable vertical bar":
                return <Tooltip title={t(label + "GROUPABLE-VERTICAL-CHART")} placement='top'>
                    <div className={`db-widget-select-item ${completeData.widgetVisualization?.id === widget.id ? "db-selected-widget" : ""}`} onClick={(e) => {
                        setCompleteData(pre => {
                            return { ...pre, widgetVisualization: { ...widget, img: GroupableVerticalChartIcon } }
                        });
                    }}>
                        <img src={GroupableVerticalChartIcon} />
                        <span className='db-widget-select-text'>{t(label + "X-AXISG")}</span>
                    </div></Tooltip>
                break;
            case "groupable horizontal bar":
                return <Tooltip title={t(label + "GROUPABLE-HORIZONTAL-CHART")} placement='top'>
                    <div className={`db-widget-select-item ${completeData.widgetVisualization?.id === widget.id ? "db-selected-widget" : ""}`} onClick={(e) => {
                        setCompleteData(pre => {
                            return { ...pre, widgetVisualization: { ...widget, img: GroupableHorizontalChartIcon } }
                        });
                    }}>
                        <img src={GroupableHorizontalChartIcon} />
                        <span className='db-widget-select-text'>{t(label + "Y-AXISG")}</span>
                    </div></Tooltip>
                break;
            case "horizontal bar":
                return <Tooltip title={t(label + "HORIZONTAL-CHART")} placement='top'>
                    <div className={`db-widget-select-item ${completeData.widgetVisualization?.id === widget.id ? "db-selected-widget" : ""}`} onClick={(e) => {
                        setCompleteData(pre => {
                            return { ...pre, widgetVisualization: { ...widget, img: HorizontalChartIcon } }
                        });
                    }}>
                        <img src={HorizontalChartIcon} />
                        <span className='db-widget-select-text'>{t(label + "Y-AXIS")}</span>
                    </div></Tooltip>
                break;

            default:
                break;
        }
    };



    return (<>
        {step === 1 ? <div>
            {data.length && data.map((section, index) => {
                return section.view_reports.length > 0
                    ? <Accordion key={index} className={classes.accordionRoot}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls={`panel${index}-content`}
                            id={`panel${index}-header`}
                        >
                            <div className={classes.summaryContent}>
                                <span className='db-create-widget-index'>{index + 1}.</span>
                                <Typography className='db-create-widget-data-title'>{t(label + section.label)}</Typography>
                                <Badge badgeContent={section.view_reports && section.view_reports.length > 0 ? section.view_reports.length : "0"} className={classes.badge} classes={{ badge: classes.badge }} />
                            </div>
                        </AccordionSummary>
                        <div className='p-10-0'>
                            {section.view_reports && section.view_reports.map((item, idx) => (
                                <ListItem key={idx} className={classes.listItem}>
                                    <div className='db-select-report-container' onClick={() => handleSelectData(item)}>
                                        <img className='transform-radio-icon' src={selectedData.label === item.label ? ActiveRadioIcon : PassiveRadioIcon} />
                                        <ListItemText className='db-create-widget-data-item' primary={t(label + item.label)} />
                                    </div>
                                    {item.count > 0 && (
                                        <img className='db-info-icon' loading="lazy" src={InfoIcon} />
                                    )}
                                </ListItem>
                            ))}
                        </div>
                    </Accordion>
                    : ""
            })}
        </div> :
            <div className='db-create-widget-form-container'>
                {selectedReport.id && columns.length && columns.map((column, index) => (
                    <Accordion key={index} expanded={expanded[column]} disabled={handleCheckDisable(column)} className={`${classes.accordionRoot} db-accordion-${column}`}
                        onChange={(e, isExpanded) => handleChange(e, isExpanded, column)}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls={`panel${index}-content`}
                            id={`panel${index}-header`}
                        >
                            <div className={classes.summaryContent}>
                                <Typography className='db-create-widget-data-title'>
                                    {t(label + column)}
                                    {(column === 'COLUMNS' || column === 'WIDGET-VISUALIZATION') && <span className='required-span'>({t('CONTENT.FLOW.REQUIRED')})</span>}
                                </Typography>
                            </div>
                        </AccordionSummary>
                        <div className='p-10-0'>
                            <ListItem className={`${classes.listItem} ${column === "CUSTOM-FILTERS" ? "widget-configuration-list-item" : ""}`}>
                                {handleShowColumnActions(column)}
                            </ListItem>
                        </div>
                    </Accordion>
                ))}
                <FormControlLabel
                    control={<GreenSwitch checked={completeData.persist_date_filter} onChange={(e) => {
                        setCompleteData(pre => {
                            return { ...pre, persist_date_filter: e.target.checked }
                        });
                    }} />}
                    label="Lock Timeframe"
                    style={{ margin: "0" }}
                />
            </div>
        }
    </>
    );
};

export default ReportsAccordion;
